// A price formatter bound to the buyer's selected display currency. Components
// call `const fmt = useFormatPrice()` and use `fmt(rubValue)` wherever they'd
// otherwise call `formatPrice` — so changing currency in the location modal
// reformats every price on screen.
import { formatPrice } from "@/lib/money";
import { useCurrency } from "@/store";

export function useFormatPrice() {
	const currency = useCurrency();
	return (rubValue: number) => formatPrice(rubValue, currency);
}
